import React, { lazy } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
export const OnboardingPage2: React.FC = () => {
  const navigate = useNavigate();
  const handleContinue = () => {
    // Navigate to the next step
    navigate('/onboarding/step3');
  };
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-529">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-530" />
      <div className="flex-1 flex flex-col items-center py-8 px-8 md:px-12" data-id="element-531">
        {/* Logo */}
        <div className="mb-6 w-48 md:w-60" data-id="element-532">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-533" />
        </div>
        {/* Step Indicator */}
        <div className="mb-6 flex items-center justify-center bg-dark-700/50 rounded-full px-8 py-2 backdrop-blur-sm" data-id="element-534">
          <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#00c853] text-white font-medium text-lg mr-4" data-id="element-535">
            2
          </div>
          <span className="text-white font-medium text-lg" data-id="element-536">Step 2/3</span>
        </div>
        {/* Headline */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-6 max-w-4xl" data-id="element-537">
          Watch The Video Below To Provide Us Access To Your Facebook Ad Account
        </h1>
        {/* Video Embed */}
        <div className="w-full max-w-4xl mb-8" data-id="element-538">
          <div className="aspect-video w-full bg-dark-700 rounded-xl overflow-hidden shadow-xl border-2 border-dark-500" data-id="element-539">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-540">
              <iframe src="https://iframe.mediadelivery.net/embed/460652/c22a0d21-3e20-411e-8eba-0ead7b8deabd?autoplay=false&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-541"></iframe>
            </div>
          </div>
        </div>
        {/* Step 1 */}
        <div className="w-full max-w-4xl text-center mb-8" data-id="element-542">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-543">
            Step 1: Connect Your Facebook Ad Account
          </h2>
          <a href="https://app.leadsie.com/connect/converter-for-marketing-services-via-social-media-co-llc/manage" className="text-2xl md:text-3xl font-bold text-[#00c853] hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-544">
            Here
          </a>
        </div>
        {/* Step 2 */}
        <div className="w-full max-w-4xl text-center mb-8" data-id="element-545">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-546">
            Step 2: Click The Button Below To Continue
          </h2>
          {/* CTA Button */}
          <div className="w-full max-w-lg mx-auto" data-id="element-547">
            <button onClick={handleContinue} className="w-full py-5 px-10 bg-[#00c853] hover:bg-[#00a844] text-white text-2xl md:text-3xl font-medium rounded-md shadow-lg shadow-[#00c853]/20 transition-all duration-200 animate-seesaw" data-id="element-548">
              Take Me To The Next Step &gt;&gt;
            </button>
          </div>
        </div>
      </div>
    </div>;
};